<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.invitation.title") }}</h4>
		<form class="flex flex_center flex_column w_100">
			<md-field :class="[{ 'md-error': errors.has('invitationCode') }]">
				<label>{{ $t("common.invitationCode") }}</label>
				<md-input v-model="form.invitationCode"
						  data-vv-name="invitationCode"
						  :data-vv-delay="500"
						  v-validate.immediate="modelValidations.invitationCode"
						  autocomplete="one-time-code"
				/>
				<span v-if="errors.has('invitationCode')" class="validation-error">{{errors.first("invitationCode") }}</span>
			</md-field>
		</form>
	</SignUpPageBase>
</template>

<script>
import {registrationApi} from "@/common/api/registrationApi";
import SignUpPageBase from "@/views/register/SignUpPageBase";
import {mapActions, mapGetters} from "vuex";

export default {
	components: { SignUpPageBase },
	data() {
		return {
			form: {
				invitationCode: "",
			},
			modelValidations: {
				invitationCode: {
					async: {
						api: this.checkInvitationCode,
						msg: this.$t("common.validation.messages._default")
					}
				}
			},
		};
	},
	created() {
		this.form.invitationCode = this.signUpData.invitationCode || this.signUpReferrer.invitationCode
	},
	computed: {
		...mapGetters({
			signUpReferrer: "local/signUpReferrer",
			signUpData: "local/signUpData"
		}),
		shouldBeSkipped() {
			return this.form.invitationCode && this.signUpReferrer.invitationCodeIsValid;
		}
	},
	methods: {
		...mapActions({
			setSignUpSettings: "local/setSignUpSettings",
		}),
		checkInvitationCode() {
			return registrationApi.checkInvitationCode(this.form.invitationCode);
		},
		beforeNext() {
			return new Promise((resolve, reject) => {
				registrationApi.getSettings(this.form.invitationCode || "")
					.then((settings) => {
						this.setSignUpSettings({
							requiresUserPassword: settings.requiresUserPassword
						});

						resolve();
					})
					.catch(reject);
			});
		}
	},
};
</script>